import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import { Spin } from 'antd';
import cs from 'classnames';

export default function CenteredLoader({ children, loading = true, className = '' }: Props) {
    return (
        <div className={cs('flex size-full h-full items-center justify-center', className)}>
            <Spin
                size="large"
                spinning={loading}
                indicator={<LoadingOutlined spin />}
            >
                {children}
            </Spin>
        </div>
    );
}

interface Props {
    children?: React.ReactNode;
    loading?: boolean;
    className?: string;
}
